import { fetchData } from '../../modules/fetchData.js';
import { renderMovies } from '../../modules/renderMovies.js';
import movies from '../JSON/programm.json';

// const path = './JSON/programm.json';
// let data = [];
const movieContainer = document.querySelector(".movie-container");

// async function getFetchedData() {
//     let data = await fetchData(path);;
//     return data;
// }

// data.push(await getFetchedData());

// let movies = data[0];

movieContainer.appendChild(renderMovies(movies));